"use strict";
exports.__esModule = true;
var stringify = require("json-stringify-safe");
exports["default"] = (function (e) {
    return e instanceof Error ? e : new Error(stringify(e));
});
